import { DeleteBodyWagesParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/deleteBodyWages/deleteBodyWagesQuery.type';
import { deleteBodyWagesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/deleteBodyWages/deleteBodyWagesQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const deleteWagesQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  DeleteBodyWagesParamsType
> => ({
  mutationKey: ['deleteBodyWagesQuery'],
  mutationFn: (params: DeleteBodyWagesParamsType) =>
    deleteBodyWagesQueryFunction(params),
});
